export const getSavedPageSize = (key: string, defaultSize: number = 10): number => {
  if (typeof window === 'undefined') return defaultSize;
  const saved = localStorage.getItem(key);
  const parsed = Number(saved);
  return (parsed && parsed > 0) ? parsed : defaultSize;
};

export const savePageSize = (key: string, size: number) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, String(size));
  }
};

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

const VIDEO_LIST_FILTER_KEY = 'video_list_filter_params';

export interface VideoListFilterState {
  gradeSubject?: string[];
  auditStatus?: string[];
  searchText?: string;
  pageSize?: number;
  current?: number;
  _timestamp?: number;
}

/**
 * 获取保存的视频列表筛选条件
 */
export const getVideoListFilter = (): VideoListFilterState | null => {
  if (typeof window === 'undefined') return null;
  try {
    const saved = localStorage.getItem(VIDEO_LIST_FILTER_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
};

/**
 * 保存视频列表筛选条件
 */
export const saveVideoListFilter = (filter: VideoListFilterState): void => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(VIDEO_LIST_FILTER_KEY, JSON.stringify({
      ...filter,
      _timestamp: Date.now(),
    }));
  } catch {
    // localStorage full or unavailable - silent fail
  }
};

/**
 * 清除视频列表筛选条件
 */
export const clearVideoListFilter = (): void => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(VIDEO_LIST_FILTER_KEY);
};
